export const REQUEST_MANUAL_ORGANIZATION_BACKUP =
  'REQUEST_MANUAL_ORGANIZATION_BACKUP'
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION'
export const UPDATE_ORGANIZATION_START = 'UPDATE_ORGANIZATION_START'
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS'
export const UPDATE_ORGANIZATION_ERROR = 'UPDATE_ORGANIZATION_ERROR'
export const UPDATE_ORGANIZATION_PHOTO = 'UPDATE_ORGANIZATION_PHOTO'
export const UPDATE_ORGANIZATION_PHOTO_START = 'UPDATE_ORGANIZATION_PHOTO_START'
export const UPDATE_ORGANIZATION_PHOTO_SUCCESS =
  'UPDATE_ORGANIZATION_PHOTO_SUCCESS'
export const ORGANIZATION_FETCH_ERROR = 'ORGANIZATION_FETCH_ERROR'
export const ORGANIZATION_JOINED_FETCH_START = 'ORGANIZATION_JOINED_FETCH_START'
export const ORGANIZATION_JOINED_FETCH_ERROR = 'ORGANIZATION_JOINED_FETCH_ERROR'
export const ORGANIZATION_JOINED_FETCHED = 'ORGANIZATION_JOINED_FETCHED'
export const ORGANIZATION_GENERATE_INVITE_TOKEN =
  'ORGANIZATION_GENERATE_INVITE_TOKEN'
export const ORGANIZATION_REMOVE_INVITE_TOKEN =
  'ORGANIZATION_REMOVE_INVITE_TOKEN'
export const UPDATE_ORGANIZATION_AUTH_PROVIDER =
  'UPDATE_ORGANIZATION_AUTH_PROVIDER'
